"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfFacilityShiftListItemDto = instanceOfPaginatedResponseOfFacilityShiftListItemDto;
exports.PaginatedResponseOfFacilityShiftListItemDtoFromJSON = PaginatedResponseOfFacilityShiftListItemDtoFromJSON;
exports.PaginatedResponseOfFacilityShiftListItemDtoFromJSONTyped = PaginatedResponseOfFacilityShiftListItemDtoFromJSONTyped;
exports.PaginatedResponseOfFacilityShiftListItemDtoToJSON = PaginatedResponseOfFacilityShiftListItemDtoToJSON;
exports.PaginatedResponseOfFacilityShiftListItemDtoToJSONTyped = PaginatedResponseOfFacilityShiftListItemDtoToJSONTyped;
const FacilityShiftListItemDto_1 = require("./FacilityShiftListItemDto");
const PaginationMetaDto_1 = require("./PaginationMetaDto");
/**
 * Check if a given object implements the PaginatedResponseOfFacilityShiftListItemDto interface.
 */
function instanceOfPaginatedResponseOfFacilityShiftListItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfFacilityShiftListItemDtoFromJSON(json) {
    return PaginatedResponseOfFacilityShiftListItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfFacilityShiftListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(FacilityShiftListItemDto_1.FacilityShiftListItemDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfFacilityShiftListItemDtoToJSON(json) {
    return PaginatedResponseOfFacilityShiftListItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfFacilityShiftListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(FacilityShiftListItemDto_1.FacilityShiftListItemDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfFacilityShiftListItemDto.js.map